// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__TbljP","label":"Labeled_label__3q8lq","divider":"Labeled_divider__TJORF"};